import React, { useRef } from 'react';
import BundledEditor from './BundledEditor'
import { UploadReportImage } from '../../api';
//import { setupSpeechToText } from './speechToText';
import { setupAWSMedicalSpeech } from './awsMedicalSpeech';
import './skin.css'

const RichText = (props) => {
  const editorRef = useRef(null);
  return (
    <>
      <BundledEditor
        onInit={(_evt, editor) => {
          editorRef.current = editor
          props.onEditorRef && props.onEditorRef(editorRef)
          setupAWSMedicalSpeech(editor)
        }}
        init={{
          height: 200,
          menubar: false,
          skin: 'oxide-dark',
          content_css: 'dark',
          autoresize_bottom_margin: 1,
          branding: false,
          statusbar: false,
          browser_spellcheck: true,
          contextmenu: false,
          image_dimensions: false,  // Disables width/height inputs in dialog
          image_style_dimensions: false,  // Prevents inline width/height styles on img tags
          plugins: [
            'advlist', 'image', 'lists',
            'table', 'autoresize', 'fullscreen', 'charmap'
          ],
          toolbar: 'undo redo blocks ' +
            'bold italic underline | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'table | image | removeformat charmap | medicalspeech',
          content_style: 'body { background-color: #121212; font-family:Helvetica,Arial,sans-serif; font-size:14px } * { margin: 0; color: #fff !important; } img { display:inline;max-width:100%;max-height:17em;width:auto;height:auto; }',
          images_upload_handler: async (blobInfo, progress) => {
            return new Promise((resolve, reject) => {
              const file = new File([blobInfo.blob()], blobInfo.filename());
              const files = [file];
              UploadReportImage(files, (file, uploadedFilePath) => {
                if (uploadedFilePath) {
                  resolve(uploadedFilePath);
                } else {
                  reject('Upload failed');
                }
              });
            });
          }
        }}
        {...props}
      />
    </>
  );
}

export default RichText